import { Fragment } from 'react';

import { useFormikContext } from 'formik';
import moment from 'moment';
import { useSelector } from 'react-redux';

import { FormBlockStyled } from '../../../../../../components/common/FormStyled/FormStyled';
import FormFieldCheckbox from '../../../../../../modules/form/components/FormFieldCheckbox';
import FormFieldDate from '../../../../../../modules/form/components/FormFieldDate';
import FormFieldInput from '../../../../../../modules/form/components/FormFieldInput';
import { useSubscriberIdContext } from '../../../../context';
import {
    personalDataDocumentAttributesSelector,
    personalDataMandatoryAttributesSelector,
    personalDataTranslationSelector,
} from '../../selectors';
import { PersonalDataType as T } from '../../types/meta';


const PersonalDataEditCommon = () => {

    const { subscriberId } = useSubscriberIdContext();

    const { getFieldProps, setFieldValue, setFieldTouched } = useFormikContext();

    const tPersonalData = useSelector(personalDataTranslationSelector());
    const tFields = { ...tPersonalData.personalDataEdit.fields, ...tPersonalData.personalData.fields };

    const documentAttributes = useSelector(personalDataDocumentAttributesSelector(subscriberId));
    const mandatoryAttributes = useSelector(personalDataMandatoryAttributesSelector(subscriberId));

    const onPatronymicChecked = () => {
        setFieldValue('personalData.patronymic', '');
        setFieldTouched('personalData.patronymic', true);
    };

    return (
        <Fragment>
            {documentAttributes.includes(T.surname) && (
                <FormFieldInput
                    dataName="edit-personal-data-surname"
                    label={tFields.surname}
                    name="personalData.surname"
                    required={mandatoryAttributes.includes(T.surname)}
                />
            )}
            {documentAttributes.includes(T.birthDate) && (
                <FormFieldDate
                    dataName="edit-personal-data-birthDate"
                    headType="separate"
                    label={tFields.birthDate}
                    maxDate={moment()}
                    minDate={moment().subtract(100, 'year')}
                    name="personalData.birthDate"
                    required={mandatoryAttributes.includes(T.birthDate)}
                />
            )}
            {documentAttributes.includes(T.name) && (
                <FormFieldInput
                    dataName="edit-personal-data-name"
                    label={tFields.name}
                    name="personalData.name"
                    required={mandatoryAttributes.includes(T.name)}
                />
            )}
            {documentAttributes.includes(T.birthPlace) && (
                <FormFieldInput
                    dataName="edit-personal-data-birthPlace"
                    label={tFields.birthPlace}
                    name="personalData.birthPlace"
                    required={mandatoryAttributes.includes(T.birthPlace)}
                />
            )}
            {documentAttributes.includes(T.patronymic) && (
                <FormBlockStyled>
                    <FormFieldInput
                        dataName="edit-personal-data-patronymic"
                        disabled={getFieldProps('personalData.patronymicIsOptional').value}
                        label={tFields.patronymic}
                        name="personalData.patronymic"
                        required={mandatoryAttributes.includes(T.patronymic)}
                    />
                    <FormFieldCheckbox
                        dataName="edit-personal-data-patronymicIsOptional"
                        label={tFields.patronymicIsOptional}
                        name="personalData.patronymicIsOptional"
                        onChange={onPatronymicChecked}
                    />
                </FormBlockStyled>
            )}
            {documentAttributes.includes(T.email) && (
                <FormFieldInput
                    dataName="edit-personal-data-email"
                    label={tFields.email}
                    name="personalData.email"
                    required={mandatoryAttributes.includes(T.email)}
                />
            )}
        </Fragment>
    );
};

export default PersonalDataEditCommon;
